






























import Vue from 'vue'
import Component from 'vue-class-component'
import {Prop} from 'vue-property-decorator'

/**
 * Datos mostrados en la vista previa
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
export class GooglePreviewData {
    constructor (public title = '', public url = '', public description = '') {}
}

/**
 * Vista previa en Google
 *
 * Componente que emula el aspecto de una entrada de la pagina de resultados
 * Google.
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component
export default class GoogleSERPPreview extends Vue {
    @Prop({default: () => new GooglePreviewData()})
    public value: GooglePreviewData

    get isEmpty (): boolean {
        return !this.value.title && !this.value.description
    }
}
